import dayjs from "dayjs";
import moment from "moment";
import { EQUIPMENT_OPTION_SORT } from "../../utils/constants";
import { DEFAULT_PAGINATION_LIMIT, DEFAULT_PAGINATION_PAGE } from "../logs/contand";

export const DEFAULT_ALARM_MANAGEMENT_HISTORY_STATE = {
  
  events: [],
  equipmentId: 'INVERTER',
  info: {
    // title: '',
    // username: '',
    sort: 'DESC',
    limit: DEFAULT_PAGINATION_LIMIT,
    page: DEFAULT_PAGINATION_PAGE,
    startDate: moment().format('YYYY-MM-DDT00:00:00.000Z'),
    endDate: moment().format('YYYY-MM-DDT23:59:59.000Z'),
  },
  startDate: moment().format('YYYY-MM-DDT00:00:00.000Z'),
  endDate: moment().format('YYYY-MM-DDT23:59:59.000Z'),
  dateWeek: [dayjs(), dayjs()],
  dateValue: [
    moment(new Date(), 'YYYY-MM-DD'),
    moment(new Date(), 'YYYY-MM-DD'),
  ],
  sort: EQUIPMENT_OPTION_SORT.value,
  loading: false,
  submit: false,
};
